import { type LucideIcon } from "lucide-react";
import { cn } from "../lib/utils";

export interface SidebarItem {
  icon: LucideIcon;
  label: string;
  path: string;
  isActive?: boolean;
}

interface SidebarProps {
  items: SidebarItem[];
  onNavigate: (path: string) => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

export function Sidebar({ items, onNavigate, header, footer, className }: SidebarProps) {
  return (
    <aside
      className={cn(
        "fixed left-0 top-0 z-40 hidden h-screen w-64 border-r bg-background lg:block",
        className
      )}
    >
      <div className="flex h-full flex-col">
        {/* Header */}
        {header && <div className="flex h-16 items-center border-b px-6">{header}</div>}

        {/* Navigation */}
        <nav className="flex-1 space-y-1 p-4">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => onNavigate(item.path)}
                className={cn(
                  "flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors",
                  item.isActive
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                )}
              >
                <Icon className="h-5 w-5" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        {/* Footer */}
        {footer && <div className="border-t p-4">{footer}</div>}
      </div>
    </aside>
  );
}
